import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useIssueList() {
  // Use toast
  const toast = useToast()

  const refIssueListTable = ref(null)

  const perPage = ref(5)
  const totalIssues = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const branchFilter = ref(null)
  const staffFilter = ref(null)
  const reasonFilter = ref(null)
  const itemFilter = ref(null)
  const dateFilterValue = ref(null)

  const current = new Date()
  const month = (current.getMonth() + 1) < 10 ? `0${(current.getMonth() + 1)}` : (current.getMonth() + 1)
  const date = (current.getDate()) < 10 ? `0${(current.getDate())}` : (current.getDate())
  const today = `${current.getFullYear()}-${month}-${date}`
  dateFilterValue.value = today

  const dataMeta = computed(() => {
    const localItemsCount = refIssueListTable.value ? refIssueListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalIssues.value,
    }
  })

  const refetchData = () => {
    refIssueListTable.value.refresh()
  }

  watch([currentPage, perPage, branchFilter, staffFilter, reasonFilter, itemFilter, dateFilterValue], () => {
    refetchData()
  })

  const reasonOptions = ref(JSON.parse(JSON.stringify([])))
  store
    .dispatch('common/fetchReasons', { id_name: 1, tag: 'Issue' })
    .then(response => {
      const { reasons } = response.data.data
      for (let i = 0; i < reasons.length; i += 1) {
        reasonOptions.value.push({ label: reasons[i].name, value: reasons[i].id.toString(), branch: reasons[i].branch })
      }
      localStorage.reasons = JSON.stringify(reasonOptions.value)
    })
    .catch(error => {
      console.log(error)
    })

  const itemOptions = ref(JSON.parse(JSON.stringify([])))
  store
    .dispatch('common/fetchItems', { id_name: 1 })
    .then(response => {
      const { items } = response.data.data
      for (let i = 0; i < items.length; i += 1) {
        itemOptions.value.push({ label: items[i].name, value: items[i].id.toString() })
      }
    })
    .catch(error => {
      console.log(error)
    })

  const fetchIssues = (ctx, callback) => {
    store
      .dispatch('issue/fetchAll', {
        q: searchQuery.value,
        per_page: perPage.value,
        page: currentPage.value,
        sort_by: sortBy.value,
        sort_desc: isSortDirDesc.value,
        branch_id: branchFilter.value,
        staff_id: staffFilter.value,
        reason: reasonFilter.value,
        item_id: itemFilter.value,
        date_range: dateFilterValue.value,
      })
      .then(response => {
        const { issues, total } = response.data.data

        callback(issues)
        totalIssues.value = total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error getting issue list',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  return {
    fetchIssues,
    perPage,
    currentPage,
    totalIssues,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refIssueListTable,

    refetchData,

    // Filters
    branchFilter,
    staffFilter,
    reasonFilter,
    itemFilter,
    dateFilterValue,

    reasonOptions,
    itemOptions,
  }
}
